export default "__VITE_ASSET__YPgC_8R$__"